
import {computed, defineComponent, onMounted, ref, defineProps, watch} from "vue";
import { useI18n } from "vue-i18n/index";
import { useRoute } from "vue-router";
import { version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import { Actions } from "@/store/enums/StoreEnums";
// import MainMenuConfig from "@/core/config/MainMenuConfig";
import {useStore} from "vuex";
import config from '../../core/config/DefaultLayoutConfig';
import {hasFeature} from "@/core/helpers/feature";
import HcIcon from "@/modern/components/ui/HcIcon.vue";

export default defineComponent({
  name: "kt-menu",
  components: { HcIcon },
  props: {
    isToggleActive: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  setup(props) {
    const { t, te } = useI18n();
    const route = useRoute();
    const scrollElRef = ref<null | HTMLElement>(null);
    const store = useStore();
    const currentLanguage = computed(() => store.getters.getCurrentLanguage || localStorage.getItem('currentLanguage'));

    (async () => {
      await store.dispatch(Actions.VERIFY_AUTH);
    })();

    onMounted(() => {
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });
    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = (match) => {
      return route.path.indexOf(match) !== -1;
    };

    const user = computed(() => {
      return store.getters.currentUser;
    });
    const MainMenuConfig = ref([]);

    const MainMenuConfigData = (language: string) => {
      return [
        {
          pages: [
            {
              heading: t(`${language}.common.dashboard`),
              route: "/dashboard",
              icon: "dashboard",
              svgIcon: "media/icons/duotune/art/art002.svg",
              fontIcon: "bi-app-indicator",
            },
          ],
        },
        {
          heading: 'Comece por aqui',
          route: "/apps/vpn",
          pages: [
            {
              heading: 'Introdução',
              route: "/training/modules/31",
              icon: "play",
              svgIcon: "media/icons/duotune/communication/com006.svg",
              fontIcon: "bi-play-circle",
            },
            {
              heading: t(`${language}.left_menu.network_access`),
              route: "/apps/vpn",
              icon: "network",
              svgIcon: "media/icons/duotune/communication/com006.svg",
              fontIcon: "bi-share",
            },
            {
              heading: t(`${language}.left_menu.global_search`),
              route: "/apps/global-search",
              icon: "search",
              svgIcon: "media/icons/duotune/communication/com006.svg",
              fontIcon: "bi-search"
            }
          ],
        },
        {
          heading: t(`${language}.left_menu.championship`),
          route: "/championship",
          pages: [
            {
              heading: t(`${language}.left_menu.championship_machines`),
              route: "/laboratory/competition-machines",
              icon: "gamepad",
              svgIcon: "media/icons/duotune/communication/com006.svg",
              fontIcon: "bi-joystick",
            },
            {
              heading: t(`${language}.left_menu.leaderboard`),
              route: "/club/leaderboard",
              icon: "trophy",
              svgIcon: "media/icons/duotune/communication/com006.svg",
              fontIcon: "bi-trophy",
            },
            {
              heading: "Ranking de Times",
              route: "/groups/ranking",
              icon: "users",
              svgIcon: "media/icons/duotune/communication/com006.svg",
              fontIcon: "bi-people",
            },
          ],
        },
        // Usar abaixo para campeonatos específicos, como o CarnavOwn, caso queira destacar eles no menu. Se não for necessário, pode remover esse bloco e deixar apenas o bloco "Championship" acima.
        // {
        //   heading: "CarnavOwn 2026",
        //   route: "/training/carnavown",
        //   pages: [
        //     {
        //       heading: "Ranking CarnavOwn",
        //       route: "/club/leaderboard/3",
        //       fontIcon: "bi-trophy",
        //     },
        //     {
        //       heading: "Desafios CarnavOwn",
        //       route: "/training/carnavown",
        //       fontIcon: "bi-gem",
        //     }
        //   ],
        // },  
        {
          heading: t(`${language}.left_menu.lessons`),
          route: "/apps",
          pages: [
            {
              heading: t(`${language}.left_menu.pathways`),
              route: "/training/learning-paths",
              icon: "layers",
              svgIcon: "media/icons/duotune/communication/com006.svg",
              fontIcon: "bi-layer-forward",
            },
            {
              heading: t(`${language}.left_menu.courses`),
              route: "/training/course-catalog",
              icon: "video",
              svgIcon: "media/icons/duotune/communication/com006.svg",
              fontIcon: "bi-camera-reels",
            },
            {
              heading: t(`${language}.left_menu.tips_and_tricks`),
              route: "/training/modules/39",
              icon: "bulb",
              svgIcon: "media/icons/duotune/ecommerce/ecm002.svg",
              fontIcon: "bi bi-lightbulb",
            }
          ],
        },
         {
          heading: t(`${language}.left_menu.practice`),
          route: "/apps",
          pages: [
            {
              heading: t(`${language}.left_menu.training_machines`),
              route: "/training/training-machines",
              icon: "server",
              svgIcon: "media/icons/duotune/communication/com006.svg",
              fontIcon: "bi-diagram-3",
            },
            {
              heading: t(`${language}.left_menu.challenges`),
              route: "/training/challenges",
              icon: "gem",
              svgIcon: "media/icons/duotune/communication/com006.svg",
              fontIcon: "bi-gem",
            },
            {
              heading: t(`${language}.left_menu.certifications`),
              route: "/certifications",
              icon: "cap",
              svgIcon: "media/icons/duotune/ecommerce/ecm002.svg",
              fontIcon: "bi bi-mortarboard"
            }
          ],
          },
        {
          heading: t(`${language}.left_menu.community`),
          route: "/apps",
          pages: [
            {
              heading: t(`${language}.left_menu.users_lists`),
              route: "/podium",
              icon: "podium",
              svgIcon: "media/icons/duotune/ecommerce/ecm002.svg",
              fontIcon: "bi bi-nut"
            },
            {
              heading: t(`${language}.left_menu.community_feed`),
              route: "/club/feed",
              icon: "chat",
              svgIcon: "media/icons/duotune/ecommerce/ecm002.svg",
              fontIcon: "bi-chat-left-quote"
            },
            {
              heading: t(`${language}.left_menu.discord_support`),
              external: true,
              route: "https://discord.gg/hackingclub",
              icon: "headset",
              svgIcon: "media/icons/duotune/communication/com006.svg",
              fontIcon: "bi-discord",
            },
             {
              heading: t(`${language}.left_menu.quimerax_news`),
              route: "/apps/quimerax-news",
              icon: "news",
              svgIcon: "media/icons/duotune/ecommerce/ecm002.svg",
              fontIcon: "bi-reception-4",
            }
          ],
        },
      ]
    }

    const updateMainMenuConfig = (language: string) => {
      //@ts-ignore
      MainMenuConfig.value = MainMenuConfigData(language);
    }

    updateMainMenuConfig(currentLanguage.value);

    watch(() => currentLanguage.value, (newLanguage) => {
      updateMainMenuConfig(newLanguage);
    });


    return {
      hasActiveChildren,
      MainMenuConfig,
      asideMenuIcons,
      version,
      translate,
      user,
      currentLanguage,
      store,
      Actions,
      hasFeature,
    };
  },
});
